"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var DynoEditorActions = _interopRequireWildcard(require("lead-flows-ui/actions/DynoEditor"));

var _Dynos = require("lead-flows-ui/selectors/Dynos");

var _FormFieldList = _interopRequireDefault(require("./FormFieldList"));

var _FormFieldAddOptions = _interopRequireDefault(require("./FormFieldAddOptions"));

var _DragDropContext = _interopRequireDefault(require("lead-flows-ui/utils/DragDropContext"));

var MAX_FORM_FIELDS = 4;

var FormFieldEditor =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FormFieldEditor, _Component);

  function FormFieldEditor() {
    (0, _classCallCheck2.default)(this, FormFieldEditor);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldEditor).apply(this, arguments));
  }

  (0, _createClass2.default)(FormFieldEditor, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowFormEditor." + suffix;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selectedLocale = _this$props.selectedLocale,
          selectedFields = _this$props.selectedFields,
          moveFormField = _this$props.moveFormField,
          removeFormField = _this$props.removeFormField,
          editFormField = _this$props.editFormField;
      var canAddMoreFields = this.props.selectedFields.length < MAX_FORM_FIELDS;
      return _react.default.createElement(_UIFormControl.default, {
        className: "dyno-editor__included-fields",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('includedFieldsSelectionHeader')
        }),
        tooltip: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('tooltip.includedField')
        })
      }, _react.default.createElement("div", {
        className: "form-field-selector"
      }, _react.default.createElement(_FormFieldList.default, {
        selectedLocale: selectedLocale,
        selectedFields: selectedFields,
        moveFormField: moveFormField,
        removeFormField: removeFormField,
        editFormField: editFormField
      }), _react.default.createElement(_FormFieldAddOptions.default, {
        enabled: canAddMoreFields
      })));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        selectedFields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
          name: _react.PropTypes.string.isRequired,
          label: _react.PropTypes.string.isRequired,
          displayOrder: _react.PropTypes.number.isRequired,
          type: _react.PropTypes.string.isRequired,
          fieldType: _react.PropTypes.string.isRequired,
          options: _react.PropTypes.array.isRequired
        })).isRequired,
        selectedLocale: _react.PropTypes.string.isRequired,
        removeFormField: _react.PropTypes.func.isRequired,
        moveFormField: _react.PropTypes.func.isRequired,
        editFormField: _react.PropTypes.func.isRequired,
        locale: _react.default.PropTypes.string
      };
    }
  }]);
  return FormFieldEditor;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedFields: (0, _Dynos.getFormFields)(state),
    selectedLocale: (0, _Dynos.getLocale)(state)
  };
};

var actionsToBind = {
  removeFormField: DynoEditorActions.removeFormField,
  moveFormField: DynoEditorActions.moveFormField
};

var _default = (0, _DragDropContext.default)()((0, _reactRedux.connect)(mapStateToProps, actionsToBind)(FormFieldEditor));

exports.default = _default;
module.exports = exports.default;